import React from "react";
import { Box, Typography } from "@mui/material";
import CreateForm from "@/templates/PromptTemplate/CreateForm";
import useCreatePromptTemplate from "./useCreatePromptTemplate";

export default function CreatePromptTemplatePage() {
  const {
    form,
    loading,
    handleSubmit,
    handleCancel,
  } = useCreatePromptTemplate();

  return (
    <Box>
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Create Prompt Template
      </Typography>
      
      <CreateForm
        form={form}
        loading={loading}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Box>
  );
}